module.exports = "<svg viewBox=\"0 0 224 235\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\"><title>Artboard 5</title><desc>Created with Sketch.</desc><defs></defs><g id=\"Page-1\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\" stroke-linecap=\"square\"><g id=\"Artboard-5\" stroke=\"#9f1b96\" stroke-width=\"20\"><path d=\"M60.8560787,68.1489719 L159.851028,167.143921\" id=\"Line-Copy\"></path><path d=\"M60.1489719,166.143921 L159.143921,67.1489719\" id=\"Line\"></path></g></g></svg>"


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/close.svg
// module id = 520
// module chunks = 1